import { useRef } from 'react';

import { Link, Text, VStack } from '@chakra-ui/react';

import { Button } from '@m/components-ui/button';
import {
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogRoot,
} from '@m/components-ui/dialog';

const STRIPE_TERMS_URL = 'https://stripe.com/legal/end-customer-ach-payments-authorization';

type ReviewPaymentPermissionsModalProps = {
  error?: boolean;
  loading?: boolean;
  onAuthorize: () => void;
  open: boolean;
};

export function ReviewPaymentPermissionsModal({
  error,
  loading,
  onAuthorize,
  open,
}: ReviewPaymentPermissionsModalProps) {
  // Focus the primary action on open so the focus ring doesn't land on the terms link.
  const authorizeButtonRef = useRef<HTMLButtonElement>(null);

  return (
    <DialogRoot
      size="md"
      open={open}
      placement="center"
      initialFocusEl={() => authorizeButtonRef.current}
      // Non-dismissable: no close affordance, no escape, no backdrop dismiss.
      closeOnEscape={false}
      closeOnInteractOutside={false}
    >
      <DialogContent>
        <DialogHeader title="Review payment permissions" />
        <DialogBody>
          <VStack gap="3" alignItems="flex-start">
            <Text>
              By clicking Authorize &amp; continue and saving your bank account for Metropolis you
              agree to authorize payments pursuant to{' '}
              <Link
                variant="underline"
                href={STRIPE_TERMS_URL}
                rel="noopener noreferrer"
                target="_blank"
              >
                these terms
              </Link>
              .
            </Text>
            {error && <Text color="text.error">Something went wrong. Please try again.</Text>}
          </VStack>
        </DialogBody>
        <DialogFooter>
          <Button
            ref={authorizeButtonRef}
            loading={loading}
            size="md"
            variant="primary"
            onClick={onAuthorize}
          >
            Authorize &amp; continue
          </Button>
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  );
}
